import * as React from 'react';

import { ModuleSocialEmbed, SocialEmbedType } from '@packages/common';

import { InstagramEmbed } from './InstagramEmbed/InstagramEmbed';
import { YouTubeEmbed } from './YouTubeEmbed/YouTubeEmbed';
import { FacebookEmbed } from './FacebookEmbed/FacebookEmbed';
import { PinterestEmbed } from './PinterestEmbed/PinterestEmbed';

const typeMap: { [key in SocialEmbedType]: React.ComponentType<any> | undefined } = {
  [SocialEmbedType.INSTAGRAM]: InstagramEmbed,
  [SocialEmbedType.FACEBOOK]: FacebookEmbed,
  [SocialEmbedType.PINTEREST]: PinterestEmbed,
  [SocialEmbedType.YOUTUBE]: YouTubeEmbed,
};

export type SocialEmbedProps = ModuleSocialEmbed & {
  className?: string;
};

export const SocialEmbed: React.FC<SocialEmbedProps> = (props) => {
  const { type } = props;
  const TypeComponent = typeMap[type];
  if (TypeComponent) {
    return <TypeComponent {...props} />;
  }
  return null;
};
